var map = {
	"./AdityaNarayanThakur_Captain_Motorsports.jpg": 8298,
	"./Akshay.jpg": 6192,
	"./Atharva Hire.jpg": 2196,
	"./Divij Sharma.jpeg": 3282,
	"./Neeraj.jpg": 4056,
	"./Swagat - VC Motorsports.jpg": 6260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6441;